import React from 'react';
import { Box } from '@mui/material';
import TouchTooltip from '../common/TouchTooltip';

// Dot colour = which zone it is in: blue received more, green about even, orange sent more.
export const ZONE_DOT_COLORS = { received_more: '#1976d2', even: '#2e7d32', sent_more: '#EB7536' };
// Same three zones and tints as the Clicks & orders balance scale (BadgeFairnessSection).
const ZONE_COLORS = ['#eceff1', '#dde3e6', '#eceff1'];

/**
 * A small click-balance bar for a list row: three zones (received more · even · sent more) with
 * one dot at `pos` (0 = all received, 1 = all sent), coloured by its zone. `edges` are the even
 * band's bounds.
 */
const BalanceTrack = ({ pos, edges = [0.4, 0.6], width = 120, tooltip }) => {
  const clamped = Math.min(Math.max(pos ?? 0.5, 0), 1);
  const widths = [edges[0], edges[1] - edges[0], 1 - edges[1]];
  const zone = clamped < edges[0] ? 'received_more' : clamped > edges[1] ? 'sent_more' : 'even';
  const bar = (
    <Box sx={{ position: 'relative', width, height: 14, display: 'flex', alignItems: 'center' }} aria-label="Click balance">
      <Box sx={{ display: 'flex', width: '100%', height: 6, borderRadius: 3, overflow: 'hidden' }}>
        {widths.map((w, i) => (
          <Box key={i} sx={{ width: `${w * 100}%`, bgcolor: ZONE_COLORS[i], borderLeft: i ? '1px solid #fff' : 'none' }} />
        ))}
      </Box>
      <Box
        sx={{
          position: 'absolute',
          left: `calc(${clamped * 100}% - 5px)`,
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: ZONE_DOT_COLORS[zone],
          border: '1px solid #fff',
        }}
      />
    </Box>
  );
  return tooltip ? <TouchTooltip title={tooltip}>{bar}</TouchTooltip> : bar;
};

export default BalanceTrack;
